import styled from "styled-components";

export const CartContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  margin-top: 2rem;
  width: 100%;
  padding: 0 1rem;

  li {
    list-style: none;
  }

  .textHead {
    display: flex;
    color: rgba(67, 67, 67, 0.75);
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 500;
    gap: 1.75rem;

    span:first-child {
      width: 434px;
    }

    span {
      width: 90px;
    }
  }

  .containerCart {
    display: flex;
    align-items: center;
    border-top: 1px solid #e0e0e0;
    gap: 1.75rem;
  }

  .containerImg {
    display: flex;
    align-items: center;
    padding: ${process.env.REACT_APP_ZKP === "true" ? "3rem 0" : null};
  }

  .descriptionProduct {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    h3 {
      font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
      font-weight: 500;
      font-size: 1.12rem;
      line-height: 127%;
      color: #212121;
      width: 15rem;
    }

    p {
      font-family: ${({ theme }) => theme.typography.fontFamily.primary};
      font-style: normal;
      font-size: 0.875rem;
      color: #616161;
    }

    div {
      display: flex;
      gap: 1rem;

      button {
        font-family: ${({ theme }) => theme.typography.fontFamily.primary};
        font-style: normal;
        font-weight: 500;
        font-size: 0.875rem;
        color: #6bbfbf;
        background: none;
        border: none;
      }

      span {
        color: #dedede;
      }
    }
  }

  .amount {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 0.5rem;
    height: 2.5rem;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.25rem;
      background: none;
      border: none;
      font-size: 1.5rem;
      color: rgba(67, 67, 67, 0.5);
    }

    span {
      display: flex;
      border: none;
      background: none;
      text-align: center;
      padding: 0.5rem;
      font-size: 1rem;
      color: #434343;
    }
  }

  .subtotal {
    text-align: end;
    padding-top: 1.5rem;
    border-top: 1.5px solid #e0e0e0;
  }

  @media (max-width: 768px) {
    .containerCart {
      flex-direction: column;
      align-items: flex-start;
    }

    .textHead {
      display: none;
    }

    .containerImg {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .subtotal {
      text-align: start;
    }
  }

  .zkp {
    display: flex;
    padding: 0.625rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    border-radius: 0.3125rem;
    background: #fff4e5;

    p {
      color: #663c00;
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 114%;
    }
  }
`;
